"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reactToSvgImageUrl = void 0;

var _server = _interopRequireDefault(require("react-dom/server.browser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var svgToDataURI = function svgToDataURI(svg) {
  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
};

var reactToSvgImageUrl = function reactToSvgImageUrl(element) {
  var svgString = _server.default.renderToStaticMarkup(element);

  return svgToDataURI(svgString);
};

exports.reactToSvgImageUrl = reactToSvgImageUrl;